<template>
	<Link :href="'/'">
		<img src="/images/logo-orthomatrix.svg" width="290" />
	</Link>
</template>

<script>
	import { Link } from '@inertiajs/inertia-vue3';

	export default {
		components: {
			Link,
		},
	}
</script>

<style lang="sass" scoped>

img
	margin-bottom: 40px

</style>
